//utils
import './utils/plugins'
import './utils/translations'
import './utils/global-components'
import Vuelidate from 'vuelidate'
//
import moment from 'moment';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueHead from 'vue-head'
import InlineSvg from 'vue-inline-svg';
import VueMeta from 'vue-meta'
import mask from 'vue-masked-input'

Vue.use(VueMeta)
Vue.use(Vuelidate)
// moment
Vue.prototype.moment = moment

//vue-inline-svg
Vue.component('inline-svg', InlineSvg);


Vue.use(VueHead)
//vue configs
Vue.config.productionTip = false;

//set token after refresh page
if (localStorage.getItem('user_token')) {
    store.commit(`auth/SET_TOKEN`, localStorage.getItem('user_token'));
}

const app = new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
        document.dispatchEvent(new Event('render-event'))
    }
});

Vue.initI18nManager().then(() => {
    app.$mount('#app')
});

